import { render, staticRenderFns } from "./punctuationDetail.vue?vue&type=template&id=0fe23280"
import script from "./punctuationDetail.vue?vue&type=script&lang=js"
export * from "./punctuationDetail.vue?vue&type=script&lang=js"
import style0 from "./punctuationDetail.vue?vue&type=style&index=0&id=0fe23280&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports